import React, { useState, useEffect } from "react";
import CustomSelect from "../../components/common/CustomSelect";
import { Sidebar } from "primereact/sidebar";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
 
import { FiCalendar } from "react-icons/fi";
import teamService from "../../components/Services/TeamService";
import HRTeamService from "../Services/teamServices";


const AllowanceFilter = ({
  visible,
  onHide,
  teams,
  startDate,
  endDate,
  selectedTeam,
  selectedUser,
  handleApplyFilter,
  clearFilters,
}) => {
  const [localStartDate, setLocalStartDate] = useState(startDate);
  const [localEndDate, setLocalEndDate] = useState(endDate);
  const [localSelectedTeam, setLocalSelectedTeam] = useState(selectedTeam);
  const [localSelectedUser, setLocalSelectedUser] = useState(selectedUser);
  const [localUsers, setLocalUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      setLocalStartDate(startDate);
      setLocalEndDate(endDate);
      setLocalSelectedTeam(selectedTeam);
      setLocalSelectedUser(selectedUser);
    }
  }, [visible, startDate, endDate, selectedTeam, selectedUser]);

  useEffect(() => {
    const fetchUsers = async () => {
      setIsLoading(true);
      try {
        if (localSelectedTeam) {
          const response = await HRTeamService.getGeoLocationTeamMembers(
            localSelectedTeam.value
          );
          const data = response.data;
          const combinedUsers =  data || [];
          setLocalUsers(combinedUsers.length > 0 ? combinedUsers : []);
        } else {
          const response = await teamService.getUserName();
          const data = response.data.users;
          setLocalUsers(data.map((user) => ({ label: user.name, value: user.id })));
        }
      } catch (error) {
        console.error("Error fetching users:", error);
        setLocalUsers([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchUsers();
  }, [localSelectedTeam]);

  const handleTeamChange = (option) => {
    setLocalSelectedTeam(option);
    setLocalSelectedUser(null);
  };

  const applyFilters = () => {
    handleApplyFilter({
      startDate: localStartDate,
      endDate: localEndDate,
      selectedTeam: localSelectedTeam,
      selectedUser: localSelectedUser,
    });
  };

  const handleClear = () => {
    setLocalStartDate(null);
    setLocalEndDate(null);
    setLocalSelectedTeam(null);
    setLocalSelectedUser(null);
    clearFilters();
  };

  return (
    <Sidebar
      header={<div className="flex align-items-center gap-2"><span className="font-bold">Filter</span></div>}
      visible={visible}
      onHide={onHide}
      position="right"
    >
      <div className="space-y-4">
        <div>
          <CustomSelect
            isClearable={true}
            placeholder="Select Team"
            options={teams}
            value={localSelectedTeam}
            onChange={handleTeamChange}
          />
        </div>
        <div>
          <CustomSelect
            isClearable={true}
            placeholder="Select User"
            options={localUsers}
            value={localSelectedUser}
            onChange={setLocalSelectedUser}
            isDisabled={isLoading}
          />
          
        </div>
        <div>
          <div className="relative w-full">
            <DatePicker
              selected={localStartDate}
              onChange={setLocalStartDate}
              placeholderText="Start Date"
              maxDate={new Date()}
              dateFormat="dd/MM/yyyy"
              className="w-full py-2 px-3 pr-[14rem] border-2 border-slate-200 hover:border-customGreen rounded-md text-gray-700"
            />
            <FiCalendar className="absolute right-5 top-3 text-gray-500 pointer-events-none" />
          </div>
        </div>
        <div>
          <div className="relative w-full">
            <DatePicker
              selected={localEndDate}
              onChange={setLocalEndDate}
              placeholderText="End Date"
              maxDate={new Date()}
              minDate={localStartDate}
              disabled={!localStartDate}
              dateFormat="dd/MM/yyyy"
              className="w-full py-2 px-3 pr-[14rem] border-2 border-slate-200 hover:border-customGreen rounded-md text-gray-700"
            />
            <FiCalendar className="absolute right-5 top-3 text-gray-500 pointer-events-none" />
          </div>
        </div>
      </div>

      <button
        className="mt-6 w-full bg-customGreen text-white py-2 px-4 rounded-md transition-colors"
        onClick={applyFilters}
      >
        Apply Filters
      </button>
      <button
        className="mt-2 w-full bg-gray-200 text-gray-800 py-2 px-4 rounded-md hover:bg-gray-300 transition-colors"
        onClick={handleClear}
      >
        Clear Filters
      </button>
    </Sidebar>
  );
};

export default AllowanceFilter;